// extracted by mini-css-extract-plugin
module.exports = {"textBorder":"About_textBorder__1qQ3C","gradText":"About_gradText__3kDGA","hand":"About_hand__e7XbC"};